// components/HreflangTags.tsx
// Adds hreflang meta tags for SEO
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getRouteKeyFromPath, getPath } from '../config/routes';

const SITE_URL = 'https://potkurikorjaus.fi';

const HreflangTags: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Remove existing hreflang tags
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());

    // Get current route info
    const routeInfo = getRouteKeyFromPath(location.pathname);
    if (!routeInfo) return;

    const languages = ['fi', 'en', 'sv'] as const;

    // Add hreflang tags for each language
    languages.forEach(lang => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = lang;
      link.href = `${SITE_URL}${getPath(routeInfo.key, lang)}`;
      document.head.appendChild(link);
    });

    // Add x-default (defaults to Finnish)
    const defaultLink = document.createElement('link');
    defaultLink.rel = 'alternate';
    defaultLink.hreflang = 'x-default';
    defaultLink.href = `${SITE_URL}${getPath(routeInfo.key, 'fi')}`;
    document.head.appendChild(defaultLink);

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${SITE_URL}${location.pathname}`);

  }, [location.pathname]);

  return null;
};

export default HreflangTags;
